import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import FleetSection from './components/FleetSection';
import ServiceAreas from './components/ServiceAreas';
import Rebates from './components/Rebates';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <FleetSection />
      <ServiceAreas />
      <Rebates />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
